import React, { useContext } from "react";
import { FormContext } from "../../metadata/MDForm";
import { Radio, Typography } from "antd";
import Row from "antd/lib/grid/row";
import Col from "antd/lib/grid/col";
import { GlobalStateContext } from "../../../context/GlobalStateProvider";

const { Text } = Typography;

export function VehicleTypeBtn({ proto, ...props }) {
  const getDisplayValue = useContext(FormContext);
  const displayValue = getDisplayValue.productSetupContext.displayDesc;
  const { isDesktop } = useContext(GlobalStateContext)

  let displayLabel = "Automobile";
  if (displayValue === "Trailer") {
    displayLabel = displayValue;
  }
  return (
    <Row>
      <Col span={isDesktop ? 4 : 24} style={{ marginBottom: isDesktop ? '' : '6px' }}>
        <Text>Vehicle Type</Text>
      </Col>
      <Col span={isDesktop ? 20 : 24}>
        <Text>{displayLabel}</Text>
      </Col>
    </Row>
  );
}
